import { Revenue } from '../../../shared/reports/model/Revenue';
import { RevenueEstablishmentDto } from '../dto/revenue.establishment.dto';
import { calculateAverage } from '../../../shared/math/calculateAverage';
import { CompanyData } from '../../../settings/model/company-data.model';

export class RevenueEstablishment {
  public name: string;
  public location: string;
  public id: number;
  public revenue: Revenue;
  public customers: number;
  public receipts: number;
  public averageRevenueCustomer: Revenue;
  public averageRevenueReceipt: Revenue;

  public static sortByNameLocation = (
    establishmentA: RevenueEstablishment,
    establishmentB: RevenueEstablishment
  ): number => {
    if (establishmentA.getNameLocation() < establishmentB.getNameLocation()) {
      return -1;
    }
    if (establishmentA.getNameLocation() > establishmentB.getNameLocation()) {
      return 1;
    }
    return 0;
  };

  public static fromDTO(
    revenueEstablishmentDto: RevenueEstablishmentDto,
    companyData: CompanyData
  ): RevenueEstablishment {
    const revenueEstablishment: RevenueEstablishment = new RevenueEstablishment();
    revenueEstablishment.id = revenueEstablishmentDto.metaData.company.id;
    revenueEstablishment.name = revenueEstablishmentDto.metaData.company.name;
    revenueEstablishment.location = companyData.location;
    const revenueTotalTaxIncl: number =
      revenueEstablishmentDto.revenue.revenueTotal.totalTaxIncl;
    const revenueTotalTaxExcl: number =
      revenueEstablishmentDto.revenue.revenueTotal.totalTaxExcl;
    const customers: number = revenueEstablishmentDto.totals.numberOfCustomers;
    const receipts: number = revenueEstablishmentDto.totals.numberOfTickets;

    revenueEstablishment.revenue = {
      taxIncl: revenueTotalTaxIncl,
      taxExcl: revenueTotalTaxExcl,
      tax: revenueEstablishment.calculateTax(
        revenueTotalTaxExcl,
        revenueTotalTaxIncl
      )
    };

    revenueEstablishment.customers = customers;
    revenueEstablishment.receipts = receipts;

    revenueEstablishment.averageRevenueCustomer = {
      taxIncl: calculateAverage(revenueTotalTaxIncl, customers),
      taxExcl: calculateAverage(revenueTotalTaxExcl, customers),
      tax: 0
    };
    revenueEstablishment.averageRevenueCustomer.tax = revenueEstablishment.calculateTax(
      revenueEstablishment.averageRevenueCustomer.taxExcl,
      revenueEstablishment.averageRevenueCustomer.taxIncl
    );

    revenueEstablishment.averageRevenueReceipt = {
      taxIncl: calculateAverage(revenueTotalTaxIncl, receipts),
      taxExcl: calculateAverage(revenueTotalTaxExcl, receipts),
      tax: 0
    };
    revenueEstablishment.averageRevenueReceipt.tax = revenueEstablishment.calculateTax(
      revenueEstablishment.averageRevenueReceipt.taxExcl,
      revenueEstablishment.averageRevenueReceipt.taxIncl
    );

    return revenueEstablishment;
  }

  public calculateTax(taxExclusive: number, taxInclusive: number): number {
    return taxInclusive - taxExclusive;
  }

  public getNameLocation(): string {
    return this.name + (this.location ? ' - ' + this.location : '');
  }
}
